import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { QualityControlFieldValuesHdrContainerModel } from "../../../../../../../models/aggregates/alg/cc/quality-control/quality-control-field-values-hdr-container.model";

import { BaseApiTemplateService } from "../../../shared/base-api-template-service.model";
import { Core2Config } from "../../../shared/core2Config";

@Injectable({
	providedIn: "root",
})
export class QualityControlFieldValuesHdrService extends BaseApiTemplateService<QualityControlFieldValuesHdrContainerModel> {
	readonly url =
		Core2Config.TENANT_DOMAIN_URL_PREFIX +
		Core2Config.ALG_CC_MODULE +
		"qc/field-values-hdrs";

	constructor(http: HttpClient) {
		super();
		this.apiUrl =
			Core2Config.DOMAIN_URL +
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/field-values-hdrs";
		this.endpoint_path =
			Core2Config.TENANT_DOMAIN_URL_PREFIX +
			Core2Config.ALG_CC_MODULE +
			"qc/field-values-hdrs";
		this.httpClient = http;
	}
}
